// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__sCB79","wrapper-nopadding":"wrapper-nopadding__335vI","loading":"loading__3-uG_","error":"error__2ygh9","table-loading":"table-loading__1TDAc","empty-val":"empty-val__5S4MM","panelheader-tools":"panelheader-tools__3CWoZ","propsPanels":"propsPanels__1qkKg","new":"new__3G4s0","marginLm":"marginLm__2mrM3","marginRm":"marginRm__3fUmV","fullWidth":"fullWidth__3IVpI","fullHeight":"fullHeight__3r7kH","noData":"noData__2xIsT","toolbar":"toolbar__3u3Xz","breadcrumb":"breadcrumb__3eth9","buttons":"buttons__3Mjts","chart-toolbar":"chart-toolbar__W5EhR"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/DetailView/styles.scss
// module id = 2261
// module chunks = 1